import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../utils/app.settings';
import { Observable } from 'rxjs';
import {
  ICustomerAdjustmentHistory,
  ICustomerAdjustmentHistoryRequest,
} from '../../interfaces/customer-adjustment-history.interface';

@Injectable({
  providedIn: 'root',
})
export class CustomerAdjustmentHistoryService {
  constructor(
    private httpClient: HttpClient,
    private appSetting: AppSettings
  ) {}

  getCustomerAdjustmentHistory(
    payload: ICustomerAdjustmentHistoryRequest
  ): Observable<ICustomerAdjustmentHistory[]> {
    const url = `${this.appSetting.customerAdjustmentHistory.urls.base}?prediccionUuid=${payload.prediccionUuid}`;
    return this.httpClient.get<ICustomerAdjustmentHistory[]>(url);
  }
}
